<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <!-- <a-form layout="inline" onSubmit="">
        <a-form-item label="活动项目">
          <j-dict-select-tag
            style="width: 300px"
            dictCode="sys_category,name,id,pid='1504707011729203201'"
            :trigger-change="true"
            @change="onEventCategory"
            placeholder="请选择活动项目"
          />
        </a-form-item>
      </a-form>
      <a-divider /> -->
      <a-skeleton v-if="loading" />
      <a-list :dataSource="dataSource" :pagination="pagination">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="item-card" @click="toDetail(item)">
            <a-row :gutter="24" justify="space-between">
              <a-col :span="_isMobile()?24:isBigCover(item)?18:6">
                <div class="img-zoom">
                  <img class="cover" :src="item.eventCover_url" alt="" />
                </div>
              </a-col>
              <a-col v-if="isBigCover(item)" :span="_isMobile()?24:6" class="item-desc">
                <h2>
                  <a-tag v-if="item.eventStatus==0">未开始</a-tag>
                  <a-tag v-if="item.eventStatus==-1">已结束</a-tag>
                  <a-tag color="green" v-if="item.eventStatus==1 || item.eventStatus==2">进行中</a-tag>
                  {{ item.eventName }}</h2>
                <h3>{{ getDictValue(item.eventCategory) }}</h3>
                <br />
                <p>开始时间：{{ item.eventBegin }}</p>
                <p>到期时间：{{ item.eventEnd }}</p>
              </a-col>
              <a-col v-else :span="_isMobile()?24:18" class="item-desc">
                <div>
                  <h2 style="display: inline;">
                    <a-tag v-if="item.eventStatus==0">未开始</a-tag>
                    <a-tag v-if="item.eventStatus==-1">已结束</a-tag>
                    <a-tag color="green" v-if="item.eventStatus==1 || item.eventStatus==2">进行中</a-tag>
                  {{ item.eventName }}</h2>
                  <a-divider type="vertical"></a-divider>
                  <a-icon type="calendar" theme="twoTone" />
                  <span> 活动时间：{{ item.eventBegin }} ~ {{ item.eventEnd }}</span>
                </div>
                <br>
                <div v-html="item.eventDesc"></div>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import { loadCategoryData } from "@/api/api";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import PhotoCard from "@/components/common/PhotoCard";
// import JCategorySelect from "@comp/jeecg/JCategorySelect";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
import "@/assets/less/animation.css";

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    PhotoCard,
    // JCategorySelect,
  },
  data() {
    return {
      dataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12,
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        pageSize: 999,
      },
      dictOptions: {},
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if(this.$route.query.type){
      this.queryParam.eventType = this.$route.query.type
    }
    
    this.getList();
    // loadCategoryData({ code: "A05" }).then((res) => {
    //   if (res.success) {
    //     this.$set(this.dictOptions, "eventCategory", res.result);
    //   }
    // });
  },
  mounted() {},
  methods: {
    getList() {
      this.loading = true;
      this.dataSource = [];
      getAction(
        "/teaching/teachingEvent/getAvailableEvent",
        this.queryParam
      ).then((res) => {
        console.log(res);
        if (res.success) {
          this.dataSource = res.result.records;
        }
        this.loading = false;
      });
    },
    isBigCover(record){
      if(record.showConfig){
        console.log(record.showConfig);
        let showConfig = JSON.parse(record.showConfig)
        
        return showConfig.bigCover == undefined ? true: showConfig.bigCover
      }else{
        return true
      }
    },
    eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    onEventCategory(v) {
      this.queryParam.eventCategory = v;
      this.getList();
    },
    getDictValue(text) {
      return text
        ? filterMultiDictText(this.dictOptions["eventCategory"], text)
        : "";
    },
    toDetail(item) {
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.img-zoom {
  width: 100%;
  max-height: 270px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.item-card {
  width: 100%;
  .item-desc {
    padding: 20px;
  }
}
.title {
  margin-top: 5px;
}
.title:hover {
  color: #1890ff;
}
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
/deep/.ant-list-item {
  cursor: pointer;
  .ant-card-body {
    padding: 0;
  }
}
.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>